
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Das ist umstritten. Die amerikanische Seuchenschutzbehörde CDC und die WHO
  geben nach wie vor an, dass der Weg über Tröpfchen dominiert, möglich, aber
  weniger häufig seien Ansteckungen über Oberflächenkontakte und Aerosole. Auch
  das Bundesamt für Gesundheit (BAG) findet Aerosol-Ansteckungen zu wenig
  relevant, um die Schutzmassnahmen darauf auszurichten.
    </p>
    <p>
  Viele Wissenschaftler denken allerdings, Aerosole seien bei der Übertragung
  mindestens so wichtig wie die anderen beiden Wege, und warnen weltweit schon
  länger davor, dass die Bedeutung der Schwebeteilchen bei Sars-CoV-2
  unterschätzt werde.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;